import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../Component/Header";

function ProductImages() {
    const { productId, productName } = useParams();
    const [images, setImages] = useState([]);

    useEffect(() => {
        const fetchProduct = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/getproducts/${productId}`);
            const result = await response.json();

            let imgs = [];
            try {
                imgs = JSON.parse(result.product.product_image || "[]");
            } catch { }

            setImages(imgs);
        };

        fetchProduct();
    }, [productId]);

    return (
        <>
            <Header />

            <h2
                className="text-center"
                style={{ color: "#000000ff", marginTop: "150px", fontSize: "2.5rem" }}
            >
                {productName}
            </h2>

            <div className="container mt-5">
                <div className="row g-4">
                    {images.map((img, index) => (
                        <div className="col-13 col-md-7 col-lg-6" key={index}>
                            <img
                                src={img}
                                alt="product"
                                style={{
                                    width: "100%",
                                    height: "550px",
                                    objectFit: "cover",
                                    borderRadius: "10px",
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default ProductImages;
